<table mat-table [dataSource]="dataSource" matSort>
  <ng-container [matColumnDef]="col.key" *ngFor="let col of columnsSchema">
    <th mat-header-cell *matHeaderCellDef>
      {{ col.label }}
    </th>
    <td mat-cell *matCellDef="let element">
      <div [ngSwitch]="col.key">
        <div class="info-name" *ngSwitchCase="'name'">
          <img src="{{ element.profileIcon }}" alt="" />
          <div class="name">
            <h4>{{ element[col.key] }}</h4>
            <small>{{ element.email }}</small>
          </div>
        </div>
        <div class="btns-action" *ngSwitchCase="'actions'">
          <button mat-button class="btn edit-btn-table">
            <i class="fas fa-pencil-alt"></i>
          </button>
          <button mat-button class="btn delete-btn-table">
            <i class="far fa-trash-alt"></i>
          </button>
        </div>
        <span class="cell-text" *ngSwitchDefault>
          {{ element[col.key] }}
        </span>
      </div>
    </td>
  </ng-container>
  <!-- <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        <div class="message-box">
          <img src="../../assets/Group 590.png" alt="" />
          <h3>No users yet</h3>
          <p>You didn’t add any user yet, let’s add new users</p>
          <stc-apps-button
            [buttonText]="'Add new user'"
            [buttonType]="'warn'"
            [buttonIcon]="' fa-plus-circle'"
          ></stc-apps-button>
        </div>
      </td>
    </tr> -->
  <!-- <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        <div class="message-box">
          <img src="../../assets/Group 597.png" alt="" />
          <h3>Sorry !</h3>
          <p>there are no data that match your search, please try again</p>
          <stc-apps-button
            [buttonText]="'Try another data sets'"
            [buttonType]="'warn'"
          ></stc-apps-button>
        </div>
      </td>
    </tr> -->
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="displayedColumns.length">
      <div class="message-box">
        <img src="assets/Group 598.png" alt="" />
        <h3>No network connection !</h3>
        <p>Please connect to the network and try again</p>
        <stc-apps-button [buttonText]="'Try again'" [buttonType]="'warn'" (btnClick)="showSuccess()"></stc-apps-button>
      </div>
    </td>
  </tr>
  <!-- <tr class="mat-row" *matError>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        No data matching the filter.
      </td>
    </tr> -->
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
<mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 15, 20]" [showFirstLastButtons]="true" [hidePageSize]="true">
</mat-paginator>